import axios from 'axios';
import { put, takeLatest, take, call, all } from 'redux-saga/effects';
import * as types from '../ActionTypes/LeaderboardsActionTypes';
import { leaderboards } from '../../BusinessLogic/Network/API/LeaderBoardsApi';
import { LeaderboardsActionCreators } from '../ActionCreators/LeaderboardsActionCreators';

export class LeaderBoardsSage {
    static *getProfileLeaderboards({ meta: { profileId } }) {
        try {
            const _leaderboards = leaderboards.create();
            const { data: response } = yield call(axios, _leaderboards.getAllLeaderboards(profileId));
            yield put(LeaderboardsActionCreators.getProfileLeaderboardsSuccess(response));
        } catch (error) {
            yield put(LeaderboardsActionCreators.getProfileLeaderboardsFailed(error));
        }
    }

    static *getWorkoutLeaderboards({ meta: { workoutId } }) {
        try {
            const _leaderboards = leaderboards.create();
            const { data: response } = yield call(axios, _leaderboards.getWorkoutLeaderboards(workoutId));
            yield put(LeaderboardsActionCreators.getWorkoutLeaderboardsSuccess(response));
        } catch (error) {
            yield put(LeaderboardsActionCreators.getWorkoutLeaderboardsFailed(error));
        }
    }

    static *loadMoreProfileLeaderboards({ meta: { profileId, paginationOffset } }) {
        try {
            const _leaderboards = leaderboards.create();
            const { data: response } = yield call(axios, _leaderboards.getAllLeaderboards(profileId, paginationOffset));
            yield put(LeaderboardsActionCreators.loadMoreProfileLeaderboardsSuccess(response));
        } catch (error) {
            yield put(LeaderboardsActionCreators.loadMoreProfileLeaderboardsFailed(error));
        }
    }

    static *loadMoreWorkoutLeaderboards({ meta: { workoutId, paginationOffset } }) {
        try {
            const _leaderboards = leaderboards.create();
            const { data: response } = yield call(
                axios,
                _leaderboards.getWorkoutLeaderboards(workoutId, paginationOffset),
            );
            yield put(LeaderboardsActionCreators.loadMoreWorkoutLeaderboardsSuccess(response));
        } catch (error) {
            yield put(LeaderboardsActionCreators.loadMoreWorkoutLeaderboardsFailed(error));
        }
    }

    static *getLeaderboardsForSlider({ meta: { profileId } }) {
        try {
            const _leaderBoards = leaderboards.create();

            if (Array.isArray(profileId)) {
                const response = yield all(
                    profileId.map(id => {
                        return call(axios, _leaderBoards.getLeaderboardsById(id));
                    }),
                );

                const sliderData = response.map(o => {
                    let _result = {};

                    _result = { ...o.data.meta };
                    _result['workout'] = o.data.meta.workout;
                    _result['users'] = o.data.data;

                    return _result;
                });

                yield put(LeaderboardsActionCreators.getLeaderboardsForSliderSuccess(sliderData));
            }
        } catch (error) {
            yield put(LeaderboardsActionCreators.getLeaderboardsForSliderFailed(error));
        }
    }

    static *updateLeaderboardUsers({ meta: { leaderboardId } }) {
        try {
            const _leaderBoards = leaderboards.create();

            let response = yield call(axios, _leaderBoards.getLeaderboardsById(leaderboardId));

            let _result = {};

            _result['id'] = response.data.meta.id;
            _result['users'] = Array.from(response.data.data);

            yield put(LeaderboardsActionCreators.updateLeaderboardUsersSuccess(_result));
        } catch (error) {
            yield put(LeaderboardsActionCreators.updateLeaderboardUsersFailed(error));
        }
    }
}

export function* saga() {
    yield takeLatest(types.GET_PROFILE_LEADERBOARDS_REQUEST, LeaderBoardsSage.getProfileLeaderboards);
    yield takeLatest(types.GET_WORKOUT_LEADERBOARDS_REQUEST, LeaderBoardsSage.getWorkoutLeaderboards);
    yield takeLatest(types.LOAD_MORE_PROFILE_LEADERBOARDS_REQUEST, LeaderBoardsSage.loadMoreProfileLeaderboards);
    yield takeLatest(types.LOAD_MORE_WORKOUT_LEADERBOARDS_REQUEST, LeaderBoardsSage.loadMoreWorkoutLeaderboards);
    yield takeLatest(types.GET_LEADERBOARDS_FOR_SLIDER_REQUEST, LeaderBoardsSage.getLeaderboardsForSlider);
    yield take(types.UPDATE_LEADERBOARD_USERS_REQUEST, LeaderBoardsSage.updateLeaderboardUsers);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/LeaderboardsSaga.js